/*
  ak-preise.js — Preis-Baustein: setzt in Seiten und Blogartikeln den aktuellen Shop-Preis ein.

  Warum: Abgetippte Preise veralten bei jeder Preisänderung, und das in fünf Sprachen (#2006, #2238, #2609).
  Der Baustein holt den Preis beim Anzeigen aus dem Shop, in Sprache, Land und Währung des Besuchers.
  Projekt Preise_Automatisch_2026_09, Vladi 18.09.2026 („Mischform, Preise in Listen automatisch behalten“).

  Was gefüllt wird:
    1. Preisfelder der handgebauten Kacheln: ein Element mit Klasse ag-…-card__price in einem Link auf ein eigenes Produkt.
    2. Markierungen im Text: <span data-ak-preis="<handle>" data-ak-variante="<id>"></span> (Variante optional).

  Welcher Preis:
    - Variante im Link bzw. in der Markierung → Preis dieser Variante.
    - Sonst ein Anker (ANKER unten) → Preis der dort genannten Variante.
    - Sonst eine einzige Preisstufe → dieser Preis, mehrere → „ab“ + günstigster Preis (wie die Produktkarten im Shop).
  Steht das Produkt nicht (mehr) im Onlineshop, auch wenn sein alter Link nur umgeleitet wird, bleibt die Stelle
  unverändert; der Preis-Wächter meldet sie. Ohne Skript oder bei einem Fehler bleibt der abgetippte Preis stehen, wie
  vor dem Baustein.

  Abruf: sections/ak-preise.liquid über die Suche, bis zu 20 Produkte je Anfrage (Grenze von all_products). Die Handles
  gehen als Suchbegriff mit, weil übersetzte Seiten übersetzte Produktadressen haben und ein Umleitungsvergleich dort
  nicht zwischen „übersetzt“ und „stillgelegt“ unterscheiden kann.

  Jede bearbeitete Stelle trägt data-ak-preis-status (live | fehlt | fehler), damit der tägliche Test im Preis-Wächter
  prüfen kann, ob der Baustein wirklich arbeitet.

  Kachelbilder: Lädt ein Bild in einem handgebauten Block (Link auf ein eigenes Produkt, Block mit Klasse ag-… bzw.
  ak-…, z. B. Kachel oder Feature) nicht, setzt der Baustein das aktuelle Hauptbild des Produkts ein. Funktionierende Bilder bleiben unberührt.
  Anlass: Vladi 18.09.2026, 150 Kachelbilder auf 20 Seiten lieferten HTTP 404, weil die Bilddateien bei früheren
  Bild-Aufräumaktionen mit den Produktbildern gelöscht wurden (Liste: Bilder_nicht_erreichbar.csv im Projektordner).
  Ersetzte Bilder tragen data-ak-bild="ersetzt".
*/
(function () {
  // Kacheln mit mehreren Preisstufen ohne „ab“ und ohne ?variant=, deren Zahl eine bestimmte Ausführung meint.
  // Schlüssel: Handle|abgetippte Zahl in Cent. Die Zahl im Text bleibt bestehen (nur die Anzeige wird ersetzt),
  // deshalb gilt der Schlüssel auch nach einer Preisänderung. Stand 18.09.2026 (werkzeuge/anker.js).
  var ANKER = {
    'nachfullkassette-fur-110-16mm-film-wiederverwendbar-zum-selbstbefullen-fur-alle-110-kameras|5995': '52331467473236',
    'ausgeknipst-px825-batterie-adapter-battery-1-5v-2x-adapter-ersatz-fur-v825px-lr53-epx825-ka825_b0cjrty78w_|2195': '52443801321812',
    'film-scanner-top-plate-120-mittelformat-6-4-5-6-7-6-9-magnetische-maske|7995': '53819622621524',
    'ebl-aaa-akku-1100mah-nimh|2595': '52661491958100',
    'ausgeknipst-filmspule-spule-quick-load-spool-wie-spoom-fur-leica-m3-m1-m2-iiig|3995': '51402276602196',
    'rewind-coupler-cap-cover-drive-abdeckkappe-von-ausgeknipst-fur-canon-f-1n-new_b0cg6nzk7y_|2995': '51920897999188',
    '4lr44-batterie-adapter-von-4-x-lr44-zu-4lr44-battery-adapter-von-ausgeknipst_b0ch3ppl1b_|1995': '51112140800340'
  };
  var KLASSE = /(^|\s)ag-[\w-]*card__price(\s|$)/;
  var EIGENER_BLOCK = /(^|\s)a[gk]-[\w-]+/;   // handgebaute Blöcke (Kachel, Feature …) tragen Klassen ag-… bzw. ak-…
  var ZAHL = /(\d{1,3}(?:[.\s ]\d{3})+|\d+)[,.](\d{2})(?!\d)/;
  var EIGENER_HOST = /(^|\.)ausgeknipst\.[a-z.]+$|^525b9c\.myshopify\.com$/i;
  var PAKET = 20;    // all_products löst je Abruf höchstens 20 Handles auf
  var PARALLEL = 3;

  function wurzel() {
    var r = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    return r || '/';
  }

  // Variantenangabe prüfen: nur eine reine Ziffernfolge gilt. Alles andere ergibt „ungueltig“, das gibt es in keinem
  // Produkt, die Stelle bleibt also unverändert.
  function variantenId(wert) {
    if (wert === null || wert === undefined) return null;
    wert = String(wert).trim();
    return /^\d+$/.test(wert) ? wert : 'ungueltig';
  }

  // Link auf ein eigenes Produkt → { handle, variante } oder null. Wie produktLink() im Preis-Wächter (preisstellen.js):
  // fremder Host oder anderes Schema (mailto:, javascript: …) → kein eigenes Produkt.
  function produktLink(a) {
    var href = (a.getAttribute('href') || '').trim();
    var host = (href.match(/^(?:https?:)?\/\/([^/?#:]+)/i) || [])[1];
    if (host ? !EIGENER_HOST.test(host) : /^[a-z][a-z0-9+.-]*:/i.test(href)) return null;
    var m = href.match(/\/products\/([^/?#"'\s<>]+)/i);
    if (!m) return null;
    var handle = m[1];
    try { handle = decodeURIComponent(handle); } catch (e) { /* bleibt roh */ }
    var v = href.match(/[?&]variant=([^&#]*)/);
    return { handle: handle.toLowerCase(), variante: v ? variantenId(v[1]) : null };
  }

  function cent(text) {
    var m = String(text || '').match(ZAHL);
    return m ? String(parseInt(m[1].replace(/[.\s ]/g, '') + m[2], 10)) : '';
  }

  function sammeln() {
    var bereich = document.getElementById('MainContent') || document.body;
    var stellen = [];
    var felder = bereich.querySelectorAll('[class*="card__price"]');
    for (var i = 0; i < felder.length; i++) {
      var el = felder[i];
      if (!KLASSE.test(el.className) || el.hasAttribute('data-ak-preis-status')) continue;
      var a = el.closest('a[href*="/products/"]');
      var link = a && produktLink(a);
      if (!link) continue;
      stellen.push({ el: el, handle: link.handle, variante: link.variante || ANKER[link.handle + '|' + cent(el.textContent)] || null });
    }
    var marken = bereich.querySelectorAll('span[data-ak-preis]');
    for (var j = 0; j < marken.length; j++) {
      var mk = marken[j];
      var h = (mk.getAttribute('data-ak-preis') || '').trim().toLowerCase();
      if (!h || mk.hasAttribute('data-ak-preis-status')) continue;
      stellen.push({ el: mk, handle: h, variante: mk.hasAttribute('data-ak-variante') ? variantenId(mk.getAttribute('data-ak-variante')) : null });
    }
    return stellen;
  }

  // Bilder in handgebauten Kacheln: Fehlschlag schon jetzt beobachten, ersetzt wird, sobald die Produktdaten da sind
  var produkte = {};
  function bildErsetzen(b) {
    var d = produkte[b.handle];
    if (!b.kaputt || !d || !d.bild || b.img.getAttribute('data-ak-bild')) return;
    // Zustand jetzt noch einmal lesen: hat inzwischen doch eine Quelle geladen, bleibt das Bild
    if (!(b.img.complete && b.img.naturalWidth === 0)) { b.kaputt = false; return; }
    b.img.setAttribute('data-ak-bild', 'ersetzt');
    b.img.removeAttribute('srcset');
    b.img.removeAttribute('sizes');
    b.img.src = d.bild;
  }
  function bilderSammeln() {
    var bereich = document.getElementById('MainContent') || document.body;
    var bilder = [];
    var imgs = bereich.querySelectorAll('a[href*="/products/"] img');
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      var a = img.closest('a[href*="/products/"]');
      // alle Vorfahren prüfen, nicht nur den nächsten mit „ag-“ im Namen (z. B. „tag-link“ enthält „ag-“)
      var eigen = false;
      for (var e = img; e && e !== bereich.parentNode; e = e.parentElement) {
        if (EIGENER_BLOCK.test(e.getAttribute('class') || '')) { eigen = true; break; }
      }
      if (!eigen) continue;
      var link = produktLink(a);
      if (!link) continue;
      var b = { img: img, handle: link.handle, kaputt: img.complete && img.naturalWidth === 0 && !!img.getAttribute('src') };
      img.addEventListener('error', (function (x) { return function () { x.kaputt = true; bildErsetzen(x); }; })(b));
      bilder.push(b);
    }
    return bilder;
  }

  // Paket von Handles → { handle: { stufen, min, ab, varianten } | null }
  function holen(paket) {
    var url = wurzel() + 'search?type=product&q=' + encodeURIComponent(paket.join(' ')) + '&section_id=ak-preise';
    return fetch(url, { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.text().then(function (html) {
        var m = html.match(/<script type="application\/json" data-ak-preise>([\s\S]*?)<\/script>/);
        if (!m) throw new Error('kein Preisblock');
        return JSON.parse(m[1]);
      });
    });
  }

  function preisText(stelle, d) {
    if (stelle.variante) return d.varianten[stelle.variante] || null;
    return d.stufen ? d.ab : d.min;
  }

  // Ergebnis eines Pakets eintragen; daten === null heißt: Abruf gescheitert
  function setzen(stellen, paket, daten) {
    if (daten) for (var h in daten) if (daten[h]) produkte[h] = daten[h];
    for (var i = 0; i < stellen.length; i++) {
      var s = stellen[i];
      if (paket.indexOf(s.handle) < 0) continue;
      var d = daten && daten[s.handle];
      var status;
      if (!daten) status = 'fehler';
      else if (!d) status = 'fehlt';
      else {
        var t = preisText(s, d);
        if (t) {
          s.el.textContent = t;
          status = 'live';
        } else status = 'fehlt';
      }
      s.el.setAttribute('data-ak-preis-status', status);
    }
  }

  function run() {
    var stellen = sammeln();
    var bilder = bilderSammeln();
    if (!stellen.length && !bilder.length) {
      document.documentElement.setAttribute('data-ak-preise', 'fertig');
      return;
    }
    var handles = [];
    for (var i = 0; i < stellen.length; i++) if (handles.indexOf(stellen[i].handle) < 0) handles.push(stellen[i].handle);
    for (var b = 0; b < bilder.length; b++) if (handles.indexOf(bilder[b].handle) < 0) handles.push(bilder[b].handle);
    var pakete = [];
    for (var p = 0; p < handles.length; p += PAKET) pakete.push(handles.slice(p, p + PAKET));
    var naechster = 0;
    function arbeiter() {
      if (naechster >= pakete.length) return Promise.resolve();
      var paket = pakete[naechster++];
      return holen(paket)
        .then(function (d) { setzen(stellen, paket, d); }, function () { setzen(stellen, paket, null); })
        .then(function () { for (var j = 0; j < bilder.length; j++) bildErsetzen(bilder[j]); })
        .then(arbeiter);
    }
    var laeufe = [];
    for (var k = 0; k < Math.min(PARALLEL, pakete.length); k++) laeufe.push(arbeiter());
    Promise.all(laeufe).then(function () { document.documentElement.setAttribute('data-ak-preise', 'fertig'); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
